module.exports = __webpack_public_path__ + "static/media/RafaelCastanedaFernandez.f9d95e27.png";